











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {ResponsavelFilial} from '@/model/resource/ResponsavelFilial'
import {ResponsavelFilialCollection} from '@/model/collection/ResponsavelFilialCollection'
import {ListResponsavelFilialSchema} from '@/schema/resource/ResponsavelFilial/ListResponsavelFilialSchema'
import {CsvResponsavelFilialSchema} from '@/schema/resource/ResponsavelFilial/CsvResponsavelFilialSchema'

@Component
export default class ListResponsavelFilialView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListResponsavelFilialSchema()
  collection = new ResponsavelFilialCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: ResponsavelFilial) {
    Helper.pushByName('editResponsavelFilial', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new ResponsavelFilialCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvResponsavelFilial()
    new CsvResponsavelFilialSchema().downloadCsv(csv.all())
  }
}
